// extracted by mini-css-extract-plugin
export var active = "_kj-e";
export var blink = "_kj-f";
export var dropDownSelector = "_kj-5";
export var dropDownWrapper = "_kj-4";
export var fakeCursor = "_kj-d";
export var fontSizeButton = "_kj-7";
export var formQuillEditor = "_kj-0";
export var pressed = "_kj-g";
export var qlBlank = "_kj-1";
export var textFormattingToolbar = "_kj-2";
export var textFormattingToolbarClosed = "_kj-3";
export var textFormattingToolbarInline = "_kj-6";
export var textToolbarOption = "_kj-8";
export var toolbarCell = "_kj-a";
export var toolbarCellCollapsed = "_kj-b";
export var toolbarOptionHitArea = "_kj-c";
export var toolbarOverflow = "_kj-9";